import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Select } from "../ui/select";
import { Button } from "../ui/button";

interface StatusUpdateProps {
  open: boolean;
  onClose: () => void;
  onUpdate: (status: any) => void;
  isPending?: boolean;
  currentStatus?: string;
}

export default function StatusUpdate({
  open,
  onClose,
  onUpdate,
  isPending = false,
  currentStatus,
}: StatusUpdateProps) {
  const [status, setStatus] = useState<string | undefined>(currentStatus);

  const handleUpdate = () => {
    if (!status) return;

    onUpdate(status);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md rounded-2xl bg-white">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-800">
            Update Status
          </DialogTitle>
        </DialogHeader>

        {/* Custom Select component */}
        <div className="mt-4">
          <Select
            value={status}
            onValueChange={(val) => setStatus(val)}
            placeholder="Choose a status"
            options={[
              { label: "ACTIVE", value: "ACTIVE" },
              { label: "INACTIVE", value: "INACTIVE" },
            ]}
          />
        </div>

        <DialogFooter className="mt-6 flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={isPending}>
            Cancel
          </Button>
          <Button
            variant="default"
            className="text-white bg-green-600 hover:bg-green-700"
            onClick={handleUpdate}
            disabled={!status || isPending}
          >
            {isPending ? "Updating..." : "Update"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
